import { Navigate } from "react-router-dom";
import { Features } from "@/types";
import { useAuth } from "@/hooks";
import { hasAccess } from "@/helpers";
import { ReactNode } from "react";

interface RequireFeatureAccessProps {
  requiredFeatures: (keyof Features)[];
  canView?: boolean[];
  redirectTo?: string;
  children: ReactNode;
}

export const RequireFeatureAccess = ({
  requiredFeatures,
  canView = [],
  redirectTo = "/",
  children,
}: RequireFeatureAccessProps) => {
  const { user } = useAuth();

  const isAllowed = hasAccess(user, requiredFeatures, ...canView);

  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};
